var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgNoMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3616 23.6929C29.0804 24.021 28.6118 24.1147 28.3306 23.8335L22.154 19H6.82739C5.77271 19 4.95239 18.1797 4.95239 17.125V5.875C4.95239 5.76787 4.96152 5.66248 4.97909 5.55965L0.307074 1.90354C-0.0209611 1.66925 -0.114685 1.20066 0.166487 0.872644L0.635109 0.263477C0.916282 -0.0176763 1.3849 -0.111394 1.71294 0.169759L6.62159 4.01105C6.68906 4.00375 6.75771 4 6.82739 4H23.0774C24.093 4 24.9524 4.85938 24.9524 5.875V17.125C24.9524 17.4974 24.8453 17.8405 24.662 18.1287L29.7365 22.0997C30.0177 22.334 30.1114 22.8026 29.8302 23.1306L29.3616 23.6929ZM23.0774 16.8886V9.89844C22.179 10.6016 20.8899 11.6172 18.9758 13.1406C18.8688 13.2197 18.7535 13.3104 18.6307 13.4088L23.0774 16.8886ZM17.1121 12.2204C17.2008 12.1479 17.2865 12.0769 17.3683 12.0091C17.5312 11.8742 17.6787 11.752 17.804 11.6562C18.6522 10.9866 19.3728 10.419 19.9905 9.93249C21.5348 8.7162 22.4357 8.0067 23.0774 7.47656V5.875H9.00347L17.1121 12.2204ZM6.82739 7.00605L14.9667 13.3755C14.9619 13.3754 14.9572 13.3752 14.9524 13.375C14.1875 13.4069 13.1885 12.5806 12.4859 11.9995C12.3274 11.8684 12.184 11.7497 12.0618 11.6562C11.5081 11.2192 11.0088 10.8256 10.5573 10.4696C8.58753 8.91678 7.5265 8.08034 6.82739 7.47656V7.00605ZM16.7365 14.7605L19.7581 17.125H6.82739V9.89844C7.44251 10.4017 8.27776 11.0651 9.40477 11.9602C9.85231 12.3156 10.3459 12.7076 10.8899 13.1406C11.0132 13.2359 11.1501 13.348 11.2992 13.4701C12.1895 14.1992 13.5136 15.2835 14.9524 15.25C15.5777 15.2649 16.1804 15.0585 16.7365 14.7605Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoMessage);
export default __webpack_public_path__ + "static/media/img-no_message.ccf5480d931c021eaf01d5b5ae3ad7ca.svg";
export { ForwardRef as ReactComponent };